import React from 'react';
import {FormGroup, Label, Input} from 'reactstrap';

interface SphereEditorProps {
    diameter: number;
    segments?: number | null;
    onChange: (diameter: number) => void;
    onSegmentsChange: (segments: number | null) => void;
}

const SphereEditor: React.FC<SphereEditorProps> = ({
    diameter,
    segments,
    onChange,
    onSegmentsChange
}) => {
    const handleDiameterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onChange(isNaN(value) ? 0 : value);
    };

    const handleSegmentsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value, 10);
        onSegmentsChange(isNaN(value) ? null : value);
    };

    return (
        <>
            <FormGroup>
                <Label>Diameter:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={diameter}
                    onChange={handleDiameterChange}
                />
            </FormGroup>
            <FormGroup>
                <Label>Segments:</Label>
                <Input
                    type="number"
                    step="1"
                    min="1"
                    value={segments ?? ''}
                    placeholder="32"
                    onChange={handleSegmentsChange}
                />
            </FormGroup>
        </>
    );
};

export default SphereEditor;
